import React from 'react';
import {DatePicker} from 'antd';
import {CalendarIcon} from '../../icons';
import IconWrapper from '../IconWrapper';
import {dateHelpers} from '../../utils/helpers';

const {RangePicker: AntRangePicker} = DatePicker;

const DATE_FORMAT = 'DD MMM YYYY';

const getSuffixIcon = (size) => (
  <IconWrapper size={size === 'small' ? 16 : 20}>
    <CalendarIcon />
  </IconWrapper>
);

const RangePicker = ({
  format = DATE_FORMAT,
  panelRender = dateHelpers.getDatePickerPanelRender,
  superNextIcon = false,
  superPrevIcon = false,
  size,
  suffixIcon = getSuffixIcon(size),
  ...props
}) => (
  <AntRangePicker
    format={format}
    panelRender={panelRender}
    superNextIcon={superNextIcon}
    superPrevIcon={superPrevIcon}
    size={size}
    suffixIcon={suffixIcon}
    {...props}
  />
);

export default RangePicker;
